import styled from '@emotion/styled';
import { fontFallback } from '@atlaskit/theme/typography';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const DropdownLabel = styled.label({
  font: `var(--ds-font-body, ${fontFallback.body.medium})`,
  fontWeight: "var(--ds-font-weight-semibold, 600)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const NameLabel = styled.span({
  marginLeft: "var(--ds-space-100, 8px)",
  color: "var(--ds-text-subtle, inherit)",
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ContainerLabel = styled.div(props => ({
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  marginBottom: props.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ContainerIcon = styled.span(props => ({
  display: 'inline-flex',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  width: 'auto',
  alignItems: 'center',
  padding: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
  borderRadius: "var(--ds-border-radius, 3px)",
  color: props.colorsConfig.fontColor,
  background: props.colorsConfig.bgColor,
  userSelect: 'none'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const Name = styled.span({
  display: 'flex',
  alignItems: 'center',
  font: `${`var(--ds-font-body-small, ${fontFallback.body.small})`}, font-weight: ${"var(--ds-font-weight-medium, 500)"}`,
  lineHeight: '14px',
  marginLeft: "var(--ds-space-025, 2px)",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const Definition = styled.div({
  color: "var(--ds-text-subtle, inherit)",
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  wordWrap: 'break-word'
});